import { Injectable } from "@angular/core";
import { IRequestInfo } from "@collections/request-info/interfaces";
import { gql, Mutation } from "apollo-angular";
import { requestInfoFragment } from "./fragments/request-info.fragment";

export interface AddPortalRequestInfoResponse{
    addPortalRequestInfo: IRequestInfo;
}

@Injectable()
export class AddPortalRequestInfoGQL extends Mutation<AddPortalRequestInfoResponse>{
    document = gql`
    mutation addPortalRequestInfo($requestInfoInput: RequestInfoInput!){
        addPortalRequestInfo(requestInfoInput: $requestInfoInput){
            ...requestInfo
        }
    }
    ${requestInfoFragment}
`;
}


